import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import erpFetcher from "@/common/fetchErpnextServices";
var DEFAULT_PAGINATION_VALUES = {
  page: 1,
  limit: 7
};
export var api__getAppointmentDays = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(request_id) {
    var _res$data, _res$data$data;
    var paginationParams,
      params,
      res,
      arr,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          paginationParams = _args.length > 1 && _args[1] !== undefined ? _args[1] : DEFAULT_PAGINATION_VALUES;
          params = _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_PAGINATION_VALUES), paginationParams), {}, {
            request_id: request_id
          });
          _context.n = 1;
          return erpFetcher().get("/inspection-appointment/reschedule-days", {
            params: params
          });
        case 1:
          res = _context.v;
          arr = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.available_days;
          return _context.a(2, arr || []);
      }
    }, _callee);
  }));
  return function api__getAppointmentDays(_x) {
    return _ref.apply(this, arguments);
  };
}();